import { ReactElement } from "react";
import { Button, Grid2 as Grid, Switch } from "@mui/material";
import { Item } from "../shared/Item";
import { useNavigate } from "react-router-dom";
import { article } from "./ArticleInterfaces";
import { changeArticleStatus } from "services/ArticleServices";

const categoryNames: Record<number, string> = {
  1: "RENT AN INFLATABLE",
  2: "BUY AN INFLATABLE",
  3: "RENT PARTY EQUIPMENT",
};

const ArticlesPreview = ({
  data,
  getData,
}: {
  data: article[];
  getData: any;
}): ReactElement => {
  const navigate = useNavigate();

  const handleEdit = (article: article) => {
    navigate("/EditArticle", { state: { data: article } });
  };

  const handleActive = async (id: number, status: boolean) => {
    const response = await changeArticleStatus(
      id,
      Boolean(status) === true ? false : true
    );

    if (response.status === 201) {
      getData();
    }
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={2}>
          <Item>ID</Item>
        </Grid>
        <Grid size={3}>
          <Item>Title</Item>
        </Grid>
        <Grid size={3}>
          <Item>Content</Item>
        </Grid>
        <Grid size={2}>
          <Item>Category</Item>
        </Grid>
        <Grid size={2}>
          <Item>Action</Item>
        </Grid>

        {data.map((article: article) => (
          <>
            <Grid size={2}>{article.id}</Grid>
            <Grid size={3}>{article.title}</Grid>
            <Grid size={3}>{article.content}</Grid>
            <Grid size={2}>{categoryNames[article.cat_id] ?? "Unknown"}</Grid>
            <Grid size={2}>
              <Button onClick={() => handleEdit(article)}>Edit</Button>
              <Switch
                name="active"
                checked={article.active}
                onChange={() => handleActive(article.id, article.active)}
              />
            </Grid>
          </>
        ))}
      </Grid>
    </>
  );
};

export default ArticlesPreview;
